<template lang="pug">
b-modal#updatePaymentOptionLimit(
  ref="updatePaymentOptionLimit"
  :title="$t('ui.combine.change_payment_option_limit')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.payment_mode')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="payment_mode"
        required
        type="text"
        :dirty="$v.payment_mode.$dirty"
        :error="$v.payment_mode.$error"
        v-model.trim.lazy="$v.payment_mode.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.payment_mode" :name="$t('ui.payment_mode')")
    b-form-group(:label="$t('ui.min_limit')").mb-0
      DebounceInput(
        size="sm"
        ref="min_limit"
        required
        type="text"
        :dirty="$v.min_limit.$dirty"
        :error="$v.min_limit.$error"
        v-model.trim.lazy="$v.min_limit.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.min_limit" :name="$t('ui.min_limit')")
    b-form-group(:label="$t('ui.max_limit')").mb-0
      DebounceInput(
        size="sm"
        ref="max_limit"
        required
        type="text"
        :dirty="$v.max_limit.$dirty"
        :error="$v.max_limit.$error"
        v-model.trim.lazy="$v.max_limit.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.max_limit" :name="$t('ui.max_limit')")
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, decimal, minValue } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      payment_mode: "",
      min_limit: null,
      max_limit: null,
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: { 
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    payment_mode: {
      required
    },
    min_limit: {
      required,
      decimal,
      minValue: minValue(0)
    },
    max_limit: {
      required,
      decimal,
      minValue: function(value) {
        return minValue(this.min_limit)(value)
      }
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.paymentOptionUpdateLimitUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          payment_mode: this.payment_mode,
          min_limit: this.min_limit,
          max_limit: this.max_limit
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.updatePaymentOptionLimit.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "change_payment_option_limit", this.feedback.status);
                  this.$refs.updatePaymentOptionLimit.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.payment_mode = "";
      this.min_limit = null
      this.max_limit = null
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.payment_mode = this.item.payment_mode;
      this.min_limit = this.item.min_limit;
      this.max_limit = this.item.max_limit;
      this.$refs.min_limit.$el.focus();
    }
  }
};
</script>
